import React from 'react';
import PropTypes from 'prop-types';

import {Wrapper} from './Wrapper';
import {BoxNode} from '../BoxNode';
import {JointNode} from '../JointNode';
import {TitleNode} from '../TitleNode';
import {Utilities} from '@learningblocks/exp-constants';
const {DESIGN_NODE_TYPE: NODE_TYPE} = Utilities;

import './style.scss';

/**
 * GroupD:
 *  - Group is reponsible for displaying the following NODE_TYPE:[ BOX_NODE, JOINT_NODE ]
 *  - Groups All Technique and Outcome Nodes associated with a Step
 *  - Used in DesignViewTwo
 *
 */
export function GroupD(props) {
  const titleNode = (n) => {
    return React.cloneElement(props.titleNode, {
      ...props.titleNode.props,
      key: n.nodeId,
      nodeTitle: n.nodeTitle,
      nodeComponents: n.nodeComponents,
    });
  };

  const boxNode = (n) => {
    return React.cloneElement(props.boxNode, {
      ...props.boxNode.props,
      key: n.nodeId,
      nodeComponents: n.nodeComponents,
    });
  };

  const jointNode = (n) => {
    return React.cloneElement(props.jointNode, {
      ...props.jointNode.props,
      key: n.nodeId,
      nodeComponents: n.nodeComponents,
    });
  };

  const groupNode = (node) => {
    switch (node.nodeType) {
      case NODE_TYPE.TITLE_NODE:
        return titleNode(node);
      case NODE_TYPE.BOX_NODE:
        return boxNode(node);
      case NODE_TYPE.JOINT_NODE:
        return jointNode(node);
      default:
        return null;
    }
  };

  const className = `design-view__groupD ${props.className}`;

  return (
    <Wrapper className={className}>{props.groupNodes.map(groupNode)}</Wrapper>
  );
}

GroupD.propTypes = {
  /**
   * List of Nodes in Group
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unqiue Id for the node
       */
      nodeId: PropTypes.number,
      /**
       * Title for the node [ occurs with TITLE_NODE ]
       */
      nodeTitle: PropTypes.arrayOf(PropTypes.object),
      /**
       * Type of Node in Group
       */
      nodeType: PropTypes.oneOf(['BOX_NODE', 'JOINT_NODE']),
      /**
       * List of components in node
       */
      nodeComponents: PropTypes.arrayOf(PropTypes.object),
    })
  ),
};

GroupD.defaultProps = {
  className: '',
  groupNodes: [],
};
